import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const HistorialRetirosPage = () => {
  const { t } = useTranslation();
  const [retiros, setRetiros] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWithdrawals = async () => {
      try {
        const res = await fetch("/api/monetizacion/withdrawals/history/", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        });
        const data = await res.json();
        setRetiros(data);
      } catch (err) {
        console.error("Error al cargar historial de retiros", err);
      } finally {
        setLoading(false);
      }
    };

    fetchWithdrawals();
  }, []);

  if (loading) return <p className="p-4">{t("withdrawals.loading")}</p>;

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white rounded-xl shadow mt-5">
              <h2
          className="text-2xl font-semibold text-center mb-4 text-[#34568B] drop-shadow-md animate-fade-in"
          style={{ animation: "fadeInUp 1s ease-out" }}
        >{t("withdrawals.title")}</h2>

      {retiros.length === 0 ? (
        <p className="text-center text-gray-600">{t("withdrawals.empty")}</p>
      ) : (
        <table className="w-full text-sm border">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 text-left">{t("withdrawals.date")}</th>
              <th className="p-2 text-left">{t("withdrawals.method")}</th>
              <th className="p-2 text-left">{t("withdrawals.tokens")}</th>
              <th className="p-2 text-left">{t("withdrawals.euros")}</th>
              <th className="p-2 text-left">{t("withdrawals.status")}</th>
            </tr>
          </thead>
          <tbody>
            {retiros.map((r) => (
              <tr key={r.id} className="border-t">
                <td className="p-2">{new Date(r.created_at).toLocaleDateString()}</td>
                <td className="p-2 capitalize">{r.method}</td>
                <td className="p-2">{r.tokens}</td>
                <td className="p-2">
                  € {r.euro_equivalent ? Number(r.euro_equivalent).toFixed(2) : "0.00"}
                </td>
                <td className="p-2 capitalize">{r.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default HistorialRetirosPage;
